import { getObjectKeyPath } from '../utils/object_utils.js';

export function forwardPropsToState(propsToCheck) {
	return function(target) {
		target.prototype.componentWillReceiveProps = function(newProps) {
			function getNewValue(it) {
				if (it.propPath) {
					return getObjectKeyPath(it.propPath, newProps);
				} else if (newProps[it.prop]) {
					return newProps[it.prop];
				}
				return it.defaultValue;
			}

			var nextState = {};
			propsToCheck
				.filter(it => this.props[it.prop] !== newProps[it.prop] || (!!this.state && newProps[it.prop] !== this.state[it.state || it.prop]))
				.forEach(it => nextState[it.state || it.prop] = getNewValue(it));

			this.setState(nextState);
		}
	};
}
